import { lighten } from 'polished'
import styled, { css, DefaultTheme } from 'styled-components'

type DocInputProps = {
  file: boolean
  disabled: boolean
  error?: boolean
}

export const Wrapper = styled.div<DocInputProps>`
  ${({ theme, file, disabled, error }) => css`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    position: relative;
    color: ${theme.ds.colors.white};
    width: 100%;
    padding: ${file ? '8px' : '16px'};
    /* min-height: 80px; */
    background-color: ${theme.ds.colors.white};
    border: 1px dashed ${theme.ds.colors.primary400};
    border-radius: ${theme.ds.typography.border.radius.small};

    input {
      display: none;
    }

    ${!!file && wrapperModifiers.fileSelected(theme, error)}
    ${!!disabled && wrapperModifiers.disabled(theme)}
  `}
`

type LabelProps = {
  disabled: boolean
}

export const Label = styled.label<LabelProps>`
  ${({ theme, disabled }) => css`
    cursor: ${disabled ? 'not-allowed' : 'pointer'};
    position: absolute;
    height: 100%;
    display: block;
    top: 0;
    left: 0;
    right: 0;
    color: ${theme.ds.colors.neutral800};
  `}
`

export const Content = styled.span`
  ${({ theme }) => css`
    width: 100%;
    display: flex;
    margin-top: 0 !important;
    flex-direction: column;
    align-items: center;
    flex-grow: 0;
    gap: 8px;
    color: ${theme.ds.colors.neutral800};
    font-size: ${theme.ds.typography.size.xsmall};
    font-weight: ${theme.ds.typography.weight.semiBold};
    overflow: hidden;
  `}
`

export const FileWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  /* justify-content: space-between; */
  width: 100%;
  max-width: 100%;
`

export const ImagePreview = styled.img`
  ${({ theme }) => css`
    width: 22px;
    height: 30px;
    object-fit: cover;
    object-position: center;
    overflow: hidden;
    padding: 1px;
    background: ${theme.ds.colors.neutral25};
    border: 0.5px solid ${theme.ds.colors.neutral100};
    border-radius: 4px;
  `}
`

export const Preview = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

type FileExtBoxProps = {
  fileExt: string
}

export const FileExtBox = styled.div<FileExtBoxProps>`
  ${({ theme, fileExt }) => css`
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 22px;
    height: 30px;
    padding: 1px;
    background: ${theme.ds.colors.neutral25};
    border: 0.5px solid ${theme.ds.colors.neutral100};
    border-radius: 4px;

    small {
      font-size: ${theme.ds.typography.size.xxxsmall};
      color: ${fileExt === 'pdf'
        ? theme.ds.colors.danger400
        : theme.ds.colors.info400};
    }
  `}
`

export const FileName = styled.p`
  font-size: ${({ theme }) => theme.ds.typography.size.xsmall};
  text-overflow: ellipsis;
  width: 100%;
  overflow: hidden;
  line-height: 1.2;
`

export const UploadWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`

export const UploadText = styled.p`
  font-size: ${({ theme }) => theme.ds.typography.size.xsmall};
  text-overflow: ellipsis;
  max-width: 100%;
  overflow: hidden;
  line-height: 1.2;
`

export const TypeList = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  height: 100%;
`

export const TypeListItem = styled.label`
  ${({ theme }) => css`
    display: grid;
    grid-template-columns: 50px auto;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    cursor: pointer;
    span {
      font-weight: ${theme.ds.typography.weight.semiBold};
      color: ${theme.ds.colors.neutral700};
      font-size: ${theme.ds.typography.size.xsmall};
    }
    &:hover {
      span {
        color: ${lighten(0.2, theme.ds.colors.neutral700)};
      }
    }

    svg path {
      stroke: ${theme.ds.colors.primary600};
    }
  `}
`

const wrapperModifiers = {
  fileSelected: (theme: DefaultTheme, error?: boolean) => css`
    border: 1px solid
      ${error ? theme.ds.colors.danger400 : theme.ds.colors.primary400};
  `,

  disabled: (theme: DefaultTheme) => css`
    cursor: not-allowed;
    color: ${theme.ds.colors.neutral800};
    &::placeholder {
      color: currentColor;
    }
    background-color: ${theme.ds.colors.neutral50};
  `
}

export const ErrorMessageSpan = styled.span`
  ${({ theme }) => css`
    margin: 4px 0 8px;
    font-size: ${theme.ds.typography.size.xxsmall};
    color: ${theme.ds.colors.danger400};
  `}
`

export const FileActions = styled.div`
  margin-top: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`
